






























































































import Vue from 'vue';
import moment from 'moment';
import { dateFormat, dateTransactionFormat } from '@/constants';
import { EventBus } from '@/event-bus';

interface Data {
  showDocumentsDialog: boolean;
  selectedDocuments: any[];
  preparedImages: any[];
  dateFormat: string;
  dateTransactionFormat: string;
}

export default Vue.extend({
  name: 'ChooseFileFromVault',
  props: {
    subtitle: {
      type: String,
      default: '',
    },
  },
  data(): Data {
    return {
      showDocumentsDialog: false,
      selectedDocuments: [],
      preparedImages: [],
      dateFormat,
      dateTransactionFormat,
    };
  },
  computed: {
    unsubmittedDocuments(): any {
      return this.$store.getters.unsubmittedDocuments.sort((a, b) => {
        const aUploadDate = moment(a.uploadDate, dateFormat),
          bUploadDate = moment(b.uploadDate, dateFormat),
          aName = a.fileName ? a.fileName.toUpperCase() : '',
          bName = b.fileName ? b.fileName.toUpperCase() : '';
        if (aName.toLowerCase() < bName.toLowerCase()) { return -1; }
        if (aName.toLowerCase() > bName.toLowerCase()) { return 1; }
        if (aName.toLowerCase() === bName.toLowerCase()) {
          if (aUploadDate.isAfter(bUploadDate)) { return -1; }
          if (aUploadDate.isBefore(bUploadDate)) { return 1; }
          if (aUploadDate.isSame(bUploadDate)) { return 0; }
        }
      });
    },
    imageDocuments(): any {
      return this.unsubmittedDocuments.filter((document) => {
        return document.fileName && !document.fileName.endsWith('.pdf');
      });
    },
  },
  methods: {
    openDialog(): void {
      if (this.unsubmittedDocuments.length) {
        this.showDocumentsDialog = true;
      } else {
        EventBus.$emit('openModal', 'Error', {
          title: 'select-document_error_no-documents-heading',
          message: 'select-document-error_no-documents-message',
        });
      }
    },
    attachSelectedFiles(): void {
      this.$emit('attachDocumentsFromEvault', this.selectedDocuments);
      this.showDocumentsDialog = false;
      this.selectedDocuments = [];
    },
  },
});
